import { ADD_MESSAGE } from 'state-management/constants/ariaNotification';

export const addMessage = (message = '', options = { translated: true }) => ({
    message,
    options,
    type: ADD_MESSAGE,
});
